import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      this.#tastaturZugang(wrapper, table);
    }
  }

  /**
   * DV 24.09.2026, WCAG 2.1.1: Eine seitlich scrollende Tabelle muss per Tastatur scrollbar sein.
   * tabindex nur, solange sie wirklich ueberlaeuft; sonst entstuende ein leerer Tab-Stopp.
   * Name aus der Tabellenueberschrift, sonst aus der ersten Zeile.
   * @param {HTMLElement} wrapper
   * @param {HTMLTableElement} table
   */
  #tastaturZugang(wrapper, table) {
    const name = (table.caption?.textContent || table.rows[0]?.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    const pruefen = () => {
      if (wrapper.scrollWidth > wrapper.clientWidth + 1) {
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('role', 'region');
        if (name) wrapper.setAttribute('aria-label', name);
      } else {
        wrapper.removeAttribute('tabindex');
        wrapper.removeAttribute('role');
        wrapper.removeAttribute('aria-label');
      }
    };
    pruefen();
    new ResizeObserver(pruefen).observe(wrapper);
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
